<template>
  <div>
    <SSubHeader pageName="Help center" :backButton="true" />
    <SLandingTopBar v-if="Object.keys(user).length === 0" />
    <div class="header-spacer--small"></div>
    <div class="header-spacer--standard"></div>
      <!-- ... end Header Standard Landing  -->
    <div class="container">
      <div class="image-header-container">
        <div class="top-header-thumb">
          <img src="/img/header-help-center.svg" class="header-img" alt="help center"/>
          <div class="img-overlay"></div>
          <div class="help-search-bar">
            <!-- insert the searchBar here -->
          </div>
        </div>
      </div>

      <section class="help-options-container">
        <h3 class="suggestions-title">Suggestions for you</h3>
        <div class="suggestions-container">
          <router-link class="suggestion" target="_blank" to="contact-us" >
            <img src="/img/contactUs-icon.png" alt="contact us icon"/>
            <span>Contact us</span>
          </router-link>
          <div class="suggestion" @click="option = 'terms-conditions'">
            <img src="/img/document-icon.png" alt="document icon"/>
            <span>Terms/conditions</span>
          </div>
          <div @click="option = 'privacy-policy'" class="suggestion">
            <img src="/img/document-icon.png" alt="document icon"/>
            <span>Privacy policy</span>
          </div>
        </div>
        <help-description :option="option" @back="option = ''" v-if="option" />
        <div class="row" v-else>
          <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="help-support-block">
              <h3 class="title">Manage your account</h3>
              <ul class="help-support-list">
                <li @click="option = 'create-account'">
                  <a href="#">Create an account in Swampum</a>
                </li>
                <li @click="option = 'log-in-out'">
                  <a href="#">Log in and out of Swampum</a>
                </li>
                <li @click="option = 'change-password'">
                  <a href="#">Change password</a>
                </li>
                <li @click="option = 'change-email'">
                  <a href="#">Change email</a>
                </li>
                <li @click="option = 'edit-profile'">
                  <a href="#">Edit your profile</a>
                </li>
                <li @click="option = 'deactivate-account'">
                  <a href="#">Deactivate account</a>
                </li>
                <li @click="option = 'reactivate-account'">
                  <a href="#">Reactivate your account</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="help-support-block">
              <h3 class="title">Items</h3>
              <ul class="help-support-list">
                <li @click="option = 'post-item'">
                  <a href="#">Posting an item in Swampum</a>
                </li>
                <li @click="option = 'post-item-group'">
                  <a href="#">Posting an item in a group</a>
                </li>
                <li @click="option = 'request-offer'">
                  <a href="#">Requesting or offering an item</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="help-support-block">
              <h3 class="title">Points system</h3>
              <ul class="help-support-list">
                <li @click="option = 'points-system-how'">
                  <a href="#">How the Swampum points system works</a>
                </li>
                <li @click="option = 'points-system-why'">
                  <a href="#">Why points instead of cash?</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="help-support-block">
              <h3 class="title">Groups</h3>
              <ul class="help-support-list">
                <li @click="option = 'create-group'">
                  <a href="#">Create a group at Swampum</a>
                </li>
                <li @click="option = 'message-group-moderator'">
                  <a href="#">Messaging a group moderator</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="help-support-block">
              <h3 class="title">
                Messages
              </h3>
              <ul class="help-support-list">
                <li @click="option = 'message-user'">
                  <a href="#">Messaging other users</a>
                </li>
                <li @click="option = 'messagin-in-groups'">
                  <a href="#">Messaging in groups</a>
                </li>
                <li @click="option = 'message-attachments'">
                  <a href="#">Attach documents and images to a message</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="help-support-block">
              <h3 class="title">
                Account access and safety
              </h3>
              <ul class="help-support-list">
                <li @click="option = 'contact'">
                  <a href="#">Contact the Swampum team</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="help-support-block">
              <h3 class="title">
                Payments
              </h3>
              <ul class="help-support-list">
                <li @click="option = 'transaction'">
                  <a href="#">Transactions between users</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="help-support-block">
              <h3 class="title">
                Search
              </h3>
              <ul class="help-support-list">
                <li @click="option = 'search'">
                  <a href="#">Find items, users and/or groups</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
    <a class="back-to-top arrow-top" href="#">
      <img src="/svg-icons/back-to-top.svg" alt="arrow" class="back-icon" />
    </a>
    <CookiesAndPrivacy v-if="!storageCookies" @cookies-privacy="accept" />
    <Footer v-if="this.loggedUser"/>
    <FooterUnlogged v-else/>
  </div>
</template>
<script>
import Footer from "@/templates/Footer";
import FooterUnlogged from "@/templates/FooterUnlogged";
import HelpDescription from "@/components/atoms/HelpDescription";
import CookiesAndPrivacy from "@/components/molecules/CookiesAndPrivacy";
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import { mapGetters } from "vuex";
import SSubHeader from '../../material-components/organisms/SSubHeader.vue';
export default {
  name: "LandingHelp",
  components: {
    Footer,
    FooterUnlogged,
    HelpDescription,
    CookiesAndPrivacy,
    SLandingTopBar,
    SSubHeader,
  },
  methods: {
    accept(a) {
      this.cookiesPrivacy = a;
    },
  },
  data() {
    return {
      cookiesPrivacy: localStorage.getItem("cookies_privacy"),
      option: "",
      loggedUser: null
    };
  },
  computed: {
    storageCookies() {
      return this.cookiesPrivacy;
    },
    ...mapGetters({
      user: "getUser",
    }),
  },
  mounted() {
    this.loggedUser = localStorage.getItem('user_id'); 
    const setOption = this.$route.query.open
    if (setOption) {
      this.option = setOption
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background-color: white;
  padding: 0;
}

.top-header-thumb {
  display: flex;
  justify-content: center;
  width: 100%;
}

.header-img {
  max-width: 1300px;
}

.img-overlay {
  max-width: 1300px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.62);
  border-radius: 3.69871px 3.69871px 0px 0px;
}

.suggestions-title {
  font-weight: 600;
}

.suggestions-container {
  text-align: center;
  margin: 40px 0;
  display: flex;
  justify-content: space-between;
}
.suggestions-container span {
  margin-left: 32px;
}

.suggestions-container a {
  text-decoration: none;
}
.suggestion {
  box-shadow: 0px 2px 3px #888da8;
  cursor: pointer;
  width: 25%;
  padding: 7px;
  border-radius: 4px;
  border: 1.5px solid #05919B;
  color: #05919B;
}
.suggestion:hover {
  transform: scale(1.02);
}
.help-search-bar {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  max-width: 1000px;
  width: 100%;
  padding: 0 50px;
}
.help-options-container {
  padding: 50px;
}

.help-support-block .title {
  font-size: 24px;
  margin-bottom: 15px;
  font-weight: 500;
}
.help-support-list li a {
  color: #05919B !important;
}

@media screen and (max-width: 768px) {
  .header-spacer--small {
    height: 80px;
  }
}
@media screen and (min-width: 601px) and (max-width: 768px) {
  .header-spacer--small {
    margin-bottom: -50px;
  }
}
@media screen and (max-width: 600px) {
  .header-spacer--small {
    margin-bottom: -35px;
  }
}
@media screen and (max-width: 1198px) {
  .suggestion {
    width: 90%;
    margin-bottom: 15px;
  }
  .suggestions-container {
    flex-direction: column;
    align-items: center;
    margin: 0px 0px;
  }
  .container {
    width: 90%;
    border-style: solid;
    border-width: thin;
  }
  .help-options-container {
    padding: 20px;
  }
}
.help-support-list li:hover a {
  color: #515365 !important;
}
.stunning-header a {
  color: #fff !important;
}
</style>
